export default __webpack_public_path__ + "static/skills-tag-colored-light-a81211e2e95c6b9f93c6f376811639267c7bd4ec3547fe42a670cef300d95603.png";